var lg_6710V00067G = {
    name: "6710V00067G",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,191,154,32],
        },
        {
            // function: "KEY_MEDIA",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [22,0,5,35,3,97,3,88,6,194,6,44,3,194,6,88,6,97,3,44,3,214,72,199,202,132],
        },
        {
            function: "KEY_TV",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,190,118,32],
        },
        {
            function: "KEY_A",
            name: "KEY_A",
            icon: "KEY_A",
            command: [24,0,4,36,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,222,105,136],
        },
        {
            function: "KEY_DIGITS",
            name: "KEY_DIGITS",
            icon: "KEY_DIGITS",
            command: [24,0,4,36,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,222,89,136],
        },
        {
            function: "KEY_INSERT",
            name: "KEY_INSERT",
            icon: "KEY_INSERT",
            command: [22,0,5,36,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,88,6,55,76,190,113,8],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,222,122,32],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [24,0,5,37,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,190,99,132],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [22,0,5,36,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,88,6,55,76,222,99,8],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [22,0,4,35,3,97,3,88,6,97,3,44,3,194,6,88,6,55,76,190,105,16],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [22,0,5,35,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,55,76,222,98,132],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [24,0,5,37,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,190,113,132],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [24,0,5,37,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,223,152,132],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,190,94,32],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [24,0,4,36,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,222,92,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [24,0,4,36,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,191,44,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,223,46,32],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [22,0,5,34,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,190,82,33],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [26,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,223,242,32],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,88,6,55,76,191,228,64],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [26,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,223,230,32],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,191,202,32],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [24,0,5,37,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,223,200,132],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,88,6,55,76,191,204,64],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [26,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,223,206,32],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,55,76,191,150,32],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [24,0,4,36,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,223,148,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [26,0,3,37,3,97,3,88,6,97,3,44,3,55,76,191,249],
        },
        {
            function: "KEY_P",
            name: "KEY_P",
            icon: "KEY_P",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,88,6,55,76,223,156,64],
        },
        {
            function: "KEY_S",
            name: "KEY_S",
            icon: "KEY_S",
            command: [22,0,5,36,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,88,6,55,76,191,35,8],
        },
        {
            function: "KEY_PROPS",
            name: "KEY_PROPS",
            icon: "KEY_PROPS",
            command: [22,0,5,35,3,97,3,88,6,194,6,44,3,194,6,88,6,97,3,44,3,214,72,199,150,132],
        },
        {
            function: "KEY_SHOP",
            name: "KEY_SHOP",
            icon: "KEY_SHOP",
            command: [22,0,5,35,3,97,3,88,6,194,6,44,3,194,6,88,6,97,3,44,3,214,72,143,154,132],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [22,0,5,34,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,214,72,222,69,33],
        },
        {
            function: "KEY_SAVE",
            name: "KEY_SAVE",
            icon: "KEY_SAVE",
            command: [22,0,5,35,3,97,3,88,6,194,6,44,3,194,6,88,6,97,3,44,3,214,72,143,149,132],
        },
        {
            function: "KEY_TIME",
            name: "KEY_TIME",
            icon: "KEY_TIME",
            command: [20,0,5,34,3,97,3,88,6,194,6,44,3,194,6,88,6,97,3,88,6,55,76,199,149,8],
        },
        {
            function: "KEY_REDO",
            name: "KEY_REDO",
            icon: "KEY_REDO",
            command: [22,0,5,35,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,44,3,55,76,190,70,132],
        },
        {
            function: "KEY_MAX",
            name: "KEY_MAX",
            icon: "KEY_MAX",
            command: [22,0,5,36,3,97,3,88,6,97,3,44,3,194,6,88,6,194,6,88,6,55,76,222,71,8],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [24,0,4,37,3,97,3,88,6,97,3,44,3,194,6,88,6,55,76,190,124,64],
        },
        {
            function: "KEY_LIST",
            name: "KEY_LIST",
            icon: "KEY_LIST",
            command: [26,0,4,37,3,97,3,88,6,97,3,44,3,194,6,44,3,214,72,223,158,32],
        },
    ]
}
export default lg_6710V00067G